<template>
  <div class="rank-info-icon">
    <svg
      v-if="data.action === 'raise'"
      :id="`rank-info-icon-${iconKey}`"
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 11V1M5 1L9 5M5 1L1 5"
        stroke="#12C971"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="data.action === 'reduce'"
      :id="`rank-info-icon-${iconKey}`"
      width="10"
      height="12"
      viewBox="0 0 10 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 1V11M5 11L9 7M5 11L1 7"
        stroke="#FF238D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <b-popover :triggers="getPopoverType()" placement="bottom" :target="`rank-info-icon-${iconKey}`">
      {{ recommendationText }}
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "rank-info-icon",
  props: ["data", "iconKey"],
  computed: {
    recommendationText() {
      if (this.data.action === "raise") {
        return `Рекомендуем повысить разряд до ${this.data.value}`;
      }
      if (this.data.action === "reduce") {
        return `Рекомендуем понизить разряд до ${this.data.value}`;
      }
      return "";
    },
  },
  methods: {
    getPopoverType() {
      const bodyWidth = document.body.clientWidth;
      if (bodyWidth < 768) {
        return "click blur";
      }
      return "hover";
    },
  },
};
</script>

<style lang="scss" scoped>
.rank-info-icon {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
